import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";

type Props = {
  data: Record<string, any>[];
  dataKey1: string;
  dataKey2: string;
  XAxisLabel: string;
  showLegend?: boolean;
};

const BarGraph = ({
  data,
  dataKey1,
  dataKey2,
  XAxisLabel,
  showLegend = true,
}: Props) => {
  const [resizeKey, setResizeKey] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setResizeKey((prev: number) => prev + 1); // Trigger re-render
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <ResponsiveContainer key={resizeKey} width="100%">
      <BarChart
        barGap={0}
        data={data}
        margin={{
          top: 20,
          right: 0,
          left: 0,
          bottom: 5,
        }}
      >
        <XAxis
          dy={3}
          allowDataOverflow
          fontWeight={"bold"}
          tick={{ fill: "#000" }}
          fontSize={"0.6vw"}
          padding={"gap"}
          dataKey={XAxisLabel}
        ></XAxis>

        <Bar
          barSize={data?.length < 4 ? 70 : 50}
          dataKey={dataKey1}
          fill="#BEBEBE"
        >
          <LabelList
            fontSize={"0.7vw"}
            fontWeight={"bold"}
            dataKey={dataKey1}
            fill="#000"
            position="top"
          />
        </Bar>
        <Bar
          barSize={data?.length < 4 ? 70 : 50}
          dataKey={dataKey2 === "Committed" ? "Commited" : dataKey2}
          fill="#86BC25"
        >
          <LabelList
            fontWeight={"bold"}
            fill="#000"
            fontSize={"0.7vw"}
            dataKey={dataKey2 === "Committed" ? "Commited" : dataKey2}
            position="top"
          />
        </Bar>
        {showLegend && (
          <Legend
            wrapperStyle={{
              textTransform: "capitalize",
              fontWeight: 400,
              top: 6,
              fontSize: "0.7vw",
              color: "#000 !important",
            }}
            verticalAlign="top"
            align="left"
          />
        )}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarGraph;
